import React, {Fragment, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {requestTelemetry} from "../../../redux/Actions/controllers.actions";
import DashboardPage from "../../../views/Dashboard/DashboardPage";
import EmptyGraphMessage from "../../../components/Charts/Containers/EmptyGraphMessage";
import {isEmpty} from "lodash";

function Telemetry() {
  const dispatch = useDispatch();
  const [telemetry, setTelemetry] = useState({});

  useEffect(() => {
    dispatch(requestTelemetry(setTelemetry));
  }, [dispatch]);

  return (
    <Fragment>
      {!isEmpty(telemetry) ? (
        <DashboardPage dashboard={telemetry} isResizable={false} isDraggable={false} />
      ) : (
        <div style={{height: "500px"}}>
          <EmptyGraphMessage message="No data found for this dashboard" />
        </div>
      )}
    </Fragment>
  );
}

Telemetry.propTypes = {};

export default Telemetry;
